module.exports = __webpack_public_path__ + "static/media/palang.6cfe3b5a.png";